@if ($node(); as transformMatrix) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot
                [node]="transformMatrix"
                [key]="'transform'"
                [selectionPossibilities]="$transformTypeSelectionPossibilities()"
                [isSelected]="transformTypeSelected"
            ></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
    @if ($transformMatrixWithParametersTranslationRotationScale(); as transformMatrixWithParametersTranslationRotationScale) {
        @if ($useMaxCoordinates() && $maxTransform()) {
            <cm-inspector-section>
                <ng-container cm-title>Translation</ng-container>
                <ng-container cm-content>
                    <div class="cm-xyz">
                        <cm-input-container>
                            <ng-container cm-inline-label>X:</ng-container>
                            <ng-container cm-input>
                                <cm-numeric-input [value]="$maxTranslateX()" (valueChange)="setMaxTranslateX($event)" [decimalPlaces]="2" />
                            </ng-container>
                        </cm-input-container>
                        <cm-input-container>
                            <ng-container cm-inline-label>Y:</ng-container>
                            <ng-container cm-input>
                                <cm-numeric-input [value]="$maxTranslateY()" (valueChange)="setMaxTranslateY($event)" [decimalPlaces]="2" />
                            </ng-container>
                        </cm-input-container>
                        <cm-input-container>
                            <ng-container cm-inline-label>Z:</ng-container>
                            <ng-container cm-input>
                                <cm-numeric-input [value]="$maxTranslateZ()" (valueChange)="setMaxTranslateZ($event)" [decimalPlaces]="2" />
                            </ng-container>
                        </cm-input-container>
                    </div>
                </ng-container>
            </cm-inspector-section>
            <cm-inspector-section>
                <ng-container cm-title>Rotation</ng-container>
                <ng-container cm-content>
                    <div class="cm-xyz">
                        <cm-input-container>
                            <ng-container cm-inline-label>X:</ng-container>
                            <ng-container cm-input>
                                <cm-numeric-input [value]="$maxRotationX()" (valueChange)="setMaxRotationX($event)" [decimalPlaces]="2" />
                            </ng-container>
                        </cm-input-container>
                        <cm-input-container>
                            <ng-container cm-inline-label>Y:</ng-container>
                            <ng-container cm-input>
                                <cm-numeric-input [value]="$maxRotationY()" (valueChange)="setMaxRotationY($event)" [decimalPlaces]="2" />
                            </ng-container>
                        </cm-input-container>
                        <cm-input-container>
                            <ng-container cm-inline-label>Z:</ng-container>
                            <ng-container cm-input>
                                <cm-numeric-input [value]="$maxRotationZ()" (valueChange)="setMaxRotationZ($event)" [decimalPlaces]="2" />
                            </ng-container>
                        </cm-input-container>
                    </div>
                </ng-container>
            </cm-inspector-section>
        } @else {
            <cm-inspector-section>
                <ng-container cm-title>Translation</ng-container>
                <ng-container cm-content>
                    <div class="cm-xyz">
                        <cm-value-slot
                            [node]="transformMatrixWithParametersTranslationRotationScale"
                            [key]="'transform'"
                            [subKey]="['translation', 0]"
                            [label]="'X'"
                        ></cm-value-slot>
                        <cm-value-slot
                            [node]="transformMatrixWithParametersTranslationRotationScale"
                            [key]="'transform'"
                            [subKey]="['translation', 1]"
                            [label]="'Y'"
                        ></cm-value-slot>
                        <cm-value-slot
                            [node]="transformMatrixWithParametersTranslationRotationScale"
                            [key]="'transform'"
                            [subKey]="['translation', 2]"
                            [label]="'Z'"
                        ></cm-value-slot>
                    </div>
                </ng-container>
            </cm-inspector-section>
            <cm-inspector-section>
                <ng-container cm-title>Rotation</ng-container>
                <ng-container cm-content>
                    <div class="cm-xyz">
                        <cm-value-slot
                            [node]="transformMatrixWithParametersTranslationRotationScale"
                            [key]="'transform'"
                            [subKey]="['rotation', 0]"
                            [label]="'X'"
                        ></cm-value-slot>
                        <cm-value-slot
                            [node]="transformMatrixWithParametersTranslationRotationScale"
                            [key]="'transform'"
                            [subKey]="['rotation', 1]"
                            [label]="'Y'"
                        ></cm-value-slot>
                        <cm-value-slot
                            [node]="transformMatrixWithParametersTranslationRotationScale"
                            [key]="'transform'"
                            [subKey]="['rotation', 2]"
                            [label]="'Z'"
                        ></cm-value-slot>
                    </div>
                </ng-container>
            </cm-inspector-section>
        }
        @if ($can().read.menu("advancedTemplateEditor") && $maxTransform()) {
            <cm-toggle [toggle]="$useMaxCoordinates()" (toggleChange)="$useMaxCoordinates.set($event)">
                <ng-container cm-text>3DS Max / Blender coordinates</ng-container>
            </cm-toggle>
        }
    }
    @if ($transformMatrixWithParametersMatrixArray(); as transformMatrixWithParametersMatrixArray) {
        <cm-inspector-section>
            <ng-container cm-content>
                @for (_ of transformMatrixWithParametersMatrixArray.parameters.transform.array; track $index) {
                    <cm-value-slot
                        [node]="transformMatrixWithParametersMatrixArray"
                        [key]="'transform'"
                        [subKey]="['array', $index]"
                        [label]="transformMatrixWithParametersMatrixArrayLabels[$index]"
                    ></cm-value-slot>
                }
            </ng-container>
        </cm-inspector-section>
    }
    @if ($transformMatrixWithParametersProduct(); as transformMatrixWithParametersProduct) {
        <cm-inspector-section>
            <ng-container cm-content>
                <cm-value-slot [node]="transformMatrixWithParametersProduct" [key]="'transform'" [subKey]="['termA']" label="A"></cm-value-slot>
                <cm-value-slot [node]="transformMatrixWithParametersProduct" [key]="'transform'" [subKey]="['termB']" label="B"></cm-value-slot>
            </ng-container>
        </cm-inspector-section>
    }
}
